module.exports = __webpack_public_path__ + "img/베팅전체삭제.304552e3.png";